module.exports = __webpack_public_path__ + "img/portrait-072.ef45f983.jpg";